import { observable, action, computed, reaction } from 'mobx';
import { isFunction } from 'lodash';
import { api } from '../services';
import { filterStore } from 'air-filter-mobx-store';
import { commonStore, translationsStore, carsStore, fleetCustomerContractsStore } from './index';

class DriversStore {
  @observable drivers = [];
  @observable availableVehiclesForAssignment = [];
  @observable loadedAt;

  constructor(filterStore) {
    this.filterStore = filterStore;
    this.commonStore = commonStore;
    this.translationsStore = translationsStore;
    this.carsStore = carsStore;
    this.fleetCustomerContractsStore = fleetCustomerContractsStore;

    reaction(
      () => this.filterStore.globalFilterFunction,
      fn => {
        const drivers = this.drivers.map(driver => {
          if (fn(driver)) {
            return { ...driver, hidden: false };
          } else {
            return { ...driver, hidden: true };
          }
        });
        this.setDrivers(drivers);
      }
    );
  }

  @action
  async load() {
    this.commonStore.loading = true;

    if (!this.commonStore.dealer) {
      await api('dealer profile').then(dealer => {
        commonStore.setDealer(dealer);
      });
    }

    if (!this.fleetCustomerContractsStore.loadedAt) {
      await this.fleetCustomerContractsStore.load();
    }
    const availableVehiclesForAssignment = fleetCustomerContractsStore.vehiclesWithStatusConnected.map(contract => {
      const { activeVehicle } = contract;
      return { plate: activeVehicle.license_plate, vin: activeVehicle.vin, make: { descrizione: activeVehicle.brand.name }, model: { descrizione: activeVehicle.model.name } };
    });

    return api('getDriversAll')
      .then(drivers => {
        drivers = drivers.map(driver => this.driverMapFn(driver));
        this.availableVehiclesForAssignment = availableVehiclesForAssignment;
        this.setDrivers(drivers);
        this.setLoadedAt();
      })
      .finally(() => (this.commonStore.loading = false));
  }

  @action setLoadedAt() {
    this.loadedAt = new Date().getTime();
  }

  @action
  setDrivers(drivers) {
    this.drivers = drivers;
  }

  @action
  addDriver(driver) {
    this.drivers.push(this.driverMapFn(driver));
  }

  @action
  updateDriver(uin, driver) {
    this.drivers = this.drivers.map(d => (d.uin === uin ? this.driverMapFn(driver) : d));
  }

  @action
  saveDriver(uin, data) {
    return new Promise((async (resolve, reject) => {
      try {
        let response = uin ? await api('updateDriver', uin, data) : await api('createDriver', data);
        if (!uin) {
          if (data.vehicle) {
            response = { ...response, cars: [data.vehicle] };
          }
          this.addDriver(response);
        } else {
          if (data.vehicle) {
            data = { ...data, cars: [data.vehicle] };
          }
          this.updateDriver(uin, data);
        }
        resolve(this.load());
      } catch (err) {
        reject(err.error);
      }
    }))

  }

  @action
  async deleteDriver(driverId) {
    await api('deleteDriver', driverId);
    return this.load();
  }

  driverMapFn = driver => {
    // const managementStatus = 'notactive';
    const managementStatus = 'active';
    const assignedVehicle = driver.cars && driver.cars[0] ? driver.cars[0] : undefined;
    return { ...driver, managementStatus, assignedVehicle };
  };

  @computed get filtered() {
    if (this.filterStore.globalFilterFunction) {
      return this.drivers.filter(this.filterStore.globalFilterFunction);
    } else {
      return this.drivers;
    }
  }

  filterLength = (filterType, attribute) => {
    if (isFunction(this.filterStore.predictionFns[`${filterType}.${attribute}`])) {
      return this[attribute].filter(this.filterStore.predictionFns[`${filterType}.${attribute}`]).length;
    }
    return this[attribute].length;
  };

  groupsLength = (filterType, attribute) => {
    if (attribute === 'all' && isFunction(this.filterStore.predictionFns[`${filterType}.${attribute}`])) {
      return this.drivers.filter(this.filterStore.predictionFns[`${filterType}.${attribute}`]).length;
    }
    if (attribute === 'active' && isFunction(this.filterStore.predictionFns[`${filterType}.${attribute}`])) {
      return this.drivers.filter(driver => driver.managementStatus === 'active').filter(this.filterStore.predictionFns[`${filterType}.${attribute}`]).length;
    }
    if (attribute === 'notactive' && isFunction(this.filterStore.predictionFns[`${filterType}.${attribute}`])) {
      return this.drivers.filter(driver => driver.managementStatus === 'notactive').filter(this.filterStore.predictionFns[`${filterType}.${attribute}`]).length;
    }
  };

  textSearchFns = searchText => driver => {
    if (
      driver.name.includes(searchText.toLowerCase()) ||
      driver.surname.includes(searchText.toLowerCase()) ||
      driver.email.includes(searchText.toLowerCase()) ||
      driver.mobile.includes(searchText.toLowerCase())
    ) {
      return true;
    }
    if (driver.assignedVehicle && driver.assignedVehicle.plate && driver.assignedVehicle.plate.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }
    return false;
  };
}

export default new DriversStore(filterStore, commonStore, translationsStore, carsStore, fleetCustomerContractsStore);



// WEBPACK FOOTER //
// ./src/stores/driversStore.js